import Vue from 'vue';
import Vuetify from 'vuetify';
import VueStorage from 'vue-localstorage';
//import VueColor from 'vue-color';
import MomentDuration from 'moment-duration-format';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueFire from 'vuefire';
import VueJsonp from 'vue-jsonp';
import MobileDetect from 'mobile-detect';

import App from './App';
import VueI18n from 'vue-i18n';
import router from './routes';
import VueResource from 'vue-resource';
import VueApi from './plugins/api.js';
import VueMoment from './plugins/moment.js';
import VueLog from './plugins/log.js';
import LangHebrew from './langs/hebrew.json';

//Very Old
//key: 'AIzaSyDZNwioleeLle6JnfCpUBsnVGDqPxbIkDs',
//Old
//key: 'AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0',
//New
//key: 'AIzaSyDnPcFSDRj26s_aoSTiHwmr53a_LloFY9Q',
let mapKey = 'AIzaSyBoTa88_jMgJnMFJRiNzovZjTprk8MOxj0';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBun7sj5tRwMXnUTnzENiwJofZgnYhr504',
        v: '3.30',
        libraries: 'places, geometry, drawing',
        language: 'he',
    }
});

Vue.use(Vuetify);
Vue.use(VueFire);
Vue.use(VueResource);
Vue.use(VueApi);
Vue.use(VueMoment);
Vue.use(VueStorage);
Vue.use(VueLog);
//Vue.use(VueColor);
Vue.use(VueJsonp);

Vue.config.productionTip = false;

const labels = { iw: LangHebrew };

Vue.use(VueI18n, labels);
const i18n = new VueI18n({
    locale: 'iw',
    fallbackLocale: 'iw',
    messages: labels
})

import Firebase from 'firebase';

import { db, fcm } from './firebase';
var usersRef = db.ref('Users');
var settingsRef = db.ref('Settings');

new Vue({
    i18n,
    el: '#app',
    router,
    template: '<App/>',
    components: { App } ,
    data() {
        return {
            detect: new MobileDetect(window.navigator.userAgent),
            device: { isMobile: false, os: '' },
            activeSubMenu: false,
            activeMobileMenu: false,
            token: null,
            loginError: '',
            config: {
                version: '1.0',
                isDebug: true,
                username: '',
                password: '',
                apiUrl: ''
            },
            timezone: null,
            weather: null,
            activeDiaryPage: { Date: '', PageKey: null, Weather: '' },
            isTest: true,
            online: false,
            user: null,
            customer: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 },
            language: 'en',
            isRTL: true,
            customersList: [],
            notification: { isShow: false, activityId: null, info: '', from: '', event: '' },
            alert: { isShow: false, message: '', timeout: 3000, isTop: true },
            isLoginFromReset: false,
            isReady: false,
            confirm: {
                isVisible: false,
                title: '',
                question: '',
                caller: '',
                isConfirmed: false
            },
            confirmAddDiaries: {
                isVisible: false,
                totalDiaries: 0,
                isConfirmed: false
            },
            confirmAddFile: {
                isVisible: false,
                caller: '',
                isConfirmed: false,
                path: ''
            },
            userTypes: ['מנהל מערכת', 'רוכש', 'מנהל עבודה', 'מפקח'],
            isNewNote: false,
            isNewGeneralNote: false,
            isNewInfoNote: false,
            isEditNote: false,
            auth: null,
            isAdmin: false,
            isCustomer: false,
            isObserver: false,
            isInspector: false,
            isContractor: false,
            userKey: null,
            messagesCounter: 0,
            selectedFile: '',
            isUpdatedPlan: false,
            settings: false,
        }
    },
    computed: {
        activePage() {
            return this.$route.name;
        },
    },
    watch: {
        userKey(val) {
            var vm = this;
            var messagesRef = db.ref('Messages').orderByChild("ToUserKey").equalTo(val); //firebase.database().ref('posts/' + postId + '/starCount');
            messagesRef.on('value', function(snapshot) {
                vm.messagesCounter = 0;
                var data = snapshot.val();
                if (data) {
                    var keys = Object.keys(data);
                    for (var k = 0; k < keys.length; k++) {
                        var key = keys[k];
                        var msg = data[key];
                        if (!msg.IsConfirmed) {
                            vm.messagesCounter++;
                        }
                    }
                }
            });
        },
        language(val) {
            i18n.locale = val;
            if (val == "iw") {
                this.isRTL = true;
            }
            else {
                this.isRTL = false;
            }
        },
        $route: function (val) {
            this.$root.activePage = val.path;
        },
        activePage: function (val) {
            console.log("Active page = " + val);
        },
        'confirm.isConfirmed'(val) {
            if (val && this.$root.confirm.caller == 'Logout') {
                this.logout();
            }
        }
    },
    created() {
        this.$ForceLog("Vue [main] is created ...");

        var vm = this;

        if ('serviceWorker' in navigator) {
            console.log("Start registring service worker ...");
            navigator.serviceWorker.register('static/fcm-sw.js')
                .then(function (registration) {
                    console.log("Service worker was registered.");
                    return fcm.useServiceWorker(registration);
                }).then(function () {
                    fcm.requestPermission().then(function () {
                        console.log('Notification permission granted.');
                        return fcm.getToken();
                    }).then(function (token) {
                        console.log('Notification token is ready.');
                        console.log(token);
                        vm.token = token;
                    }).catch(function (err) {
                        console.log('Unable to get permission to notify.', err);
                    });
                }).catch(function (err) {
                    console.log("Service worker failed :", err)
                    //alert(err)
                });
        }
        else {
            //alert('serviceWorker not available')
        }

        fcm.onMessage(function (payload) {
            console.log("Message received. ", payload);

            var notificationOptions = {
                body: payload.notification.body,
                icon: payload.notification.icon
            };
            new Notification(payload.notification.title, notificationOptions);
        });

        //isMobile
        console.log("this.detect.mobile() >> " + vm.detect.mobile());
        console.log("this.detect.phone() >> " + vm.detect.phone());
        console.log("this.detect.tablet() >> " + vm.detect.tablet());
        console.log("this.detect.userAgent() >> " + vm.detect.userAgent());
        console.log("this.detect.os() >> " + vm.detect.os());
        console.log("this.detect.is('iPhone') >> " + vm.detect.is('iPhone'));
        console.log("this.detect.is('AndroidOS') >> " + vm.detect.is('AndroidOS'));
        console.log("this.detect.version('Webkit') >> " + vm.detect.version('Webkit'));

        vm.user = vm.$localStorage.get('user');
        console.log(JSON.stringify(vm.user));

        vm.device.isMobile = false;
        vm.device.isTablet = false;

        if (vm.detect.phone()) {
            vm.device.isMobile = true;
            vm.activeSubMenu = false;
            vm.device.os = this.detect.os();
            console.log(">>> Run on mobile <<<");
        }
        else if (vm.detect.tablet()) {
            vm.device.isTablet = true;
            vm.activeSubMenu = true;
            console.log(">>> Run on tablet <<<");
        }
        else {
            vm.activeSubMenu = true;
            console.log(">>> Run on browser <<<");
        }

        if (vm.user != null) {
            vm.user = JSON.parse(vm.user);
            //vm.login(vm.user.Username, vm.user.Password);

            vm.userKey = vm.user['.key'];

            vm.isAdmin = (vm.user.Type == 'מנהל מערכת');
            vm.isCustomer = (vm.user.Type == 'רוכש');
            vm.isObserver = (vm.user.Type == 'משקיף');
            vm.isInspector = (vm.user.Type == 'מפקח');
            vm.isContractor = (vm.user.Type == 'מנהל עבודה');

            if (vm.$route.path == "/" || vm.$route.path == "Login") {
                vm.loginDirect();
            }
        }
        else {
            vm.goto('Login');
        }
    },
    ready() {
        this.$Log("Vue [main] is ready ...");
    },
    mounted() {
        this.$Log("Vue [main] is mounted ...");

    },
    updated() {
        this.$Log("Vue [main] is updated ...");
    },
    watch: {
        isCustomer(val) {
            if (val) {
                this.loadCustomer();
            }
        }
    },
    firebase: function () {
        var vm = this;
        return {
            settings: settingsRef.orderByKey()
        }
    },
    methods: {
        appClick(event) {
            this.$Log('app11');
        },
        loadCustomer() {
            //alert('loadCustomer');
        },
        goto(page) {
            this.$router.push({ name: page });
        },
        confirmSignout() {
            this.$root.confirm = {
                isVisible: true,
                title: 'تسجيل الخروج',
                question: 'هل أنت متأكد ترغب بتسجيل الخروج?',
                caller: 'Signout',
                isConfirmed: false
            }
        },
        logout() {
            var vm = this;
            vm.$root.user = null;
            vm.$localStorage.remove('user');
            vm.goto('Login');
        },
        loginDirect() {
            var vm = this;
            vm.$Log("Vue [main] is loginDirect ...");

            //if (vm.isAdmin) {
            //    vm.goto('Diaries');
            //}
            //else {
            //    vm.goto('MyDiaries');
            //}

            vm.goto('Diaries');
        },
        login(username, password) {
            var vm = this;

            vm.isAdmin = false;
            vm.isCustomer = false;
            vm.isObserver = false;
            vm.isInspector = false;
            vm.isContractor = false;
            
            if (vm.isValidLogin(username, password)) {
                usersRef.orderByChild("Username").equalTo(username.toLowerCase()).once('value').then(function (snapshot) {
                    var obj = snapshot.val();
                    
                    if (obj) {
                        var key = Object.keys(obj)[0];
                        var usr = obj[key];
                        if (usr.Password == password) {
                            vm.user = usr;
                            vm.user.Token = vm.token;
                            var userRef = db.ref("Users/" + key);
                            userRef.set(vm.$root.user);

                            vm.user['.key'] = key;
                            vm.userKey = vm.user['.key'];
                            vm.$localStorage.set('user', JSON.stringify(vm.$root.user));
                            console.log(JSON.stringify(vm.user));

                            vm.isAdmin = (vm.user.Type == 'מנהל מערכת');
                            vm.isCustomer = (vm.user.Type == 'רוכש');
                            vm.isObserver = (vm.user.Type == 'משקיף');
                            vm.isInspector = (vm.user.Type == 'מפקח');
                            vm.isContractor = (vm.user.Type == 'מנהל עבודה');

                            vm.goto('Diaries');

                            //////if (vm.isAdmin) {
                            //////    vm.$root.goto('Diaries');
                            //////}
                            //////else {
                            //////    vm.$root.goto('MyDiaries');
                            //////}
                            //switch (vm.$root.user.Type) {
                            //    case 'מנהל מערכת': vm.$root.goto('/');
                            //    case 'רוכש': vm.$root.goto('MyDiaries');
                            //    case 'מנהל עבודה': vm.$root.goto('MyDiaries');
                            //    case 'מפקח': vm.$root.goto('MyDiaries');
                            //    case 'משקיף': vm.$root.goto('MyDiaries');
                            //    default: vm.$root.goto('Login');;
                            //}
                        }
                        else {
                            vm.loginError = "* שם משתמש או סיסמה לא נכונים";
                        }
                    }
                    else {
                        vm.loginError = "* שם משתמש או סיסמה לא נכונים";
                    }
                });
            }
            else {
                //alert('Not vaild')
            }
        },
        isValidLogin(username, password) {
            var vm = this;
            var valid = false;
            vm.loginError = "";

            if (username == undefined || username.length == 0) {
                vm.loginError = "* נא הכנס שם משתמש";
            }
            else {
                if (password == undefined || password.length == 0) {
                    vm.loginError = "* נא הכנס סיסמה";
                }
                else {
                    valid = true;
                }
            }

            return valid;
        },
    }
});



// WEBPACK FOOTER //
// ./src/main.js